// src/context/ContactModalContext.tsx
import React, { createContext, useContext, useState } from 'react';
import FloatingContactButton from '../components/FloatingContactButton/FloatingContactButton';
import ContactModal from '../components/ContactModal/ContactModal';

interface ContactModalContextProps {
  openModal: (briefTitle?: string, nctCode?: string, otherStudyId?: string) => void;
  closeModal: () => void;
  open: boolean;
  briefTitle?: string;
  nctCode?: string;
  otherStudyId?: string;
}

const ContactModalContext = createContext<ContactModalContextProps>({
  openModal: () => {},
  closeModal: () => {},
  open: false,
  briefTitle: undefined,
  nctCode: undefined,
  otherStudyId: undefined,
});

export const useContactModal = () => useContext(ContactModalContext);

export const ContactModalProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [briefTitle, setBriefTitle] = useState<string | undefined>(undefined);
  const [nctCode, setNctCode] = useState<string | undefined>(undefined);
  const [otherStudyId, setOtherStudyId] = useState<string | undefined>(undefined);

  // Lee la variable de entorno para mostrar (o no) el botón flotante
  const showFloatingButton = import.meta.env.VITE_ENABLE_FLOATING_BUTTON === 'true';

  const openModal = (title?: string, code?: string, otherId?: string) => {
    console.log('openModal called with:', { title, code, otherId });
    setBriefTitle(title);
    setNctCode(code);
    setOtherStudyId(otherId);
    setOpen(true);
  };

  const closeModal = () => {
    setOpen(false);
    setBriefTitle(undefined);
    setNctCode(undefined);
    setOtherStudyId(undefined);
  };

  return (
    <ContactModalContext.Provider value={{ openModal, closeModal, open, briefTitle, nctCode, otherStudyId }}>
      {children}

      {/* El modal se renderiza siempre, de modo que cualquier botón puede abrirlo */}
      <ContactModal
        open={open}
        onClose={closeModal}
        briefTitle={briefTitle}
        nctCode={nctCode}
        otherStudyId={otherStudyId}
      />

      {/* El botón flotante sólo se muestra si la variable de entorno está en 'true' */}
      {showFloatingButton && <FloatingContactButton />}
    </ContactModalContext.Provider>
  );
};
